/**
 * Validate a coordinate string as "latitude, longitude".
 * Returns an error message or null if valid.
 */
export function validateCoordinates(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return 'Coordinates are required';
  }

  const parts = trimmed.split(',');
  if (parts.length !== 2) {
    return 'Coordinates must be a pair of numbers separated by comma, e.g. "45.9376, 14.8049"';
  }

  const lat = parseFloat(parts[0].trim());
  const lng = parseFloat(parts[1].trim());

  if (isNaN(lat) || isNaN(lng)) {
    return 'Coordinates must be valid numbers, e.g. "45.9376, 14.8049"';
  }

  if (lat < -90 || lat > 90) {
    return `Latitude must be between -90 and 90, got ${lat}`;
  }

  if (lng < -180 || lng > 180) {
    return `Longitude must be between -180 and 180, got ${lng}`;
  }

  return null;
}
